import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { CrmBoardQuery } from '@upme/contracts';
import { CrmBoard } from '../../../features/crm/components/crm-board';
import { crmBoardOptions, crmCitiesOptions } from '../../../features/crm/queries';

const crmSearchSchema = CrmBoardQuery.catch({ segment: 'all' });

export const Route = createFileRoute('/_authenticated/crm/')({
  staticData: { breadcrumb: 'Доска' },
  validateSearch: crmSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(crmBoardOptions(deps)),
      context.queryClient.ensureQueryData(crmCitiesOptions()),
    ]);
  },
  component: CrmBoardPage,
});

function CrmBoardPage() {
  const search = Route.useSearch();
  const { data: cities } = useSuspenseQuery(crmCitiesOptions());

  return <CrmBoard filters={search} cities={cities} />;
}
